export default __webpack_public_path__ + "static/media/mobile_step_1_En.4fa2ed70.jpg";